import strings from 'strings';

export const PERSISTENCE_KEY = 'candidateQuickEntry';
export const COPIES = strings.inventory.quickEntry.table;

export const ORDER_BY_OPTIONS = {
  column: 'id',
  direction: 'desc'
};

export const COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'name',
    label: COPIES.columns.name,
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'preview',
    label: COPIES.columns.preview,
    options: {
      sort: false,
      display: true
    }
  }
];

// WIP: Mocked data for development purposes
export const MOCKED_DATA = [
  {
    id: 7,
    name: 'Jonathan Doe',
    preview:
      "1 · ESTABLISHING URGENCY. Their motivation and how serious they are — why they're looking and for how long, what they've already done about it, what they'd do if offered, when they could start, and anything personal or professional that could hold them back...."
  },
  {
    id: 8,
    name: 'Alex Smith',
    preview:
      "1 · ESTABLISHING URGENCY. Their motivation and how serious they are — why they're looking and for how long, what they've already done about it, what they'd do if offered, when they could start, and anything personal or professional that could hold them back...."
  }
];
